/* eslint-disable camelcase,quotes */
import {
	ConfidenceLevel,
	CommitmentFilterType,
	TeamRoleType,
	OneOnOneTeamRoleType,
	TeamMemberStatusType
} from "@teaming/common-enums";

export default {
	//
	// ConfidenceChip
	//
	[ `ConfidenceChip_${ ConfidenceLevel.LOW }Label` ]: "Low",
	[ `ConfidenceChip_${ ConfidenceLevel.MEDIUM }Label` ]: "Medium",
	[ `ConfidenceChip_${ ConfidenceLevel.HIGH }Label` ]: "High",

	// KeyResult (general)
	KeyResult_BinaryChoice_COMPLETE: "Complete",
	KeyResult_BinaryChoice_INCOMPLETE: "Incomplete",

	// UserAvatarSpread
	UserAvatarSpread_organizer: "Organizer",

	// TeamingUserDropDown
	TeamingUserDropDown__selectUser: "Select a user",

	// CommitmentFilters
	[ `CommitmentFilters_${ CommitmentFilterType.COMPLETE }Label` ]: "Completed",
	[ `CommitmentFilters_${ CommitmentFilterType.DUE_IN_NEXT_WEEK }Label` ]: "Due within 7 days",
	[ `CommitmentFilters_${ CommitmentFilterType.NO_DUE_DATE }Label` ]: "No due date",
	[ `CommitmentFilters_${ CommitmentFilterType.OUTSTANDING }Label` ]: "Open",
	[ `CommitmentFilters_${ CommitmentFilterType.OVERDUE }Label` ]: "Overdue",

	// DiscComparisonSection
	DiscComparisonSection_comparisonBehaviorTitle: "What comes naturally to {name}",
	DiscComparisonSection_comparisonEnergizesTitle: "What energizes {name}",
	DiscComparisonSection_comparisonDrainsTitle: "What drains {name}",
	DiscComparisonSection_comparisonSelfPronoun: "you",

	// DiscProfile
	DiscProfile_tendenciesTitle: "Tendencies",
	DiscProfile_strengthsTitle: "Strengths",
	DiscProfile_challengesTitle: "Challenges",
	DiscProfile_greatLeaderHeader: "What makes you a great leader:",
	DiscProfile_watchOutHeader: "What to watch out for:",

	// OneOnOneListHeaderCard
	OneOnOneListHeaderCard_nameColumnHeader: "Name",
	OneOnOneListHeaderCard_statusColumnHeader: "Status",
	OneOnOneListHeaderCard_roleColumnHeader: "Their Role",

	// OneOnOneListCard
	OneOnOneListCard_sampleChipLabel: "Sample",

	// LinkDialog
	LinkDialog_saveBtnLabel: "Save",
	LinkDialog_cancelBtnLabel: "Cancel",
	LinkDialog_urlFieldLabel: "URL",
	LinkDialog_invalidLinkMessage: "Please enter a valid url",

	// ImageDialog
	ImageDialog_saveBtnLabel: "Save",
	ImageDialog_cancelBtnLabel: "Cancel",
	ImageDialog_urlFieldLabel: "URL",
	ImageDialog_titleFieldLabel: "Title (optional)",
	ImageDialog_invalidLinkMessage: "Please enter a valid url",

	// CommitmentAssignees
	CommitmentAssignees_unassignItem: "Unassign",

	// CommitmentCalendar
	CommitmentCalendar__removeButtonLabel: "Remove due date",
	CommitmentCalendar__cancelButtonLabel: "Cancel",

	// TeamingToolbarButton
	TeamingToolbarButton_topicLabel: "Topic",
	TeamingToolbarButton_decisionLabel: "Decision",
	TeamingToolbarButton_commitmentLabel: "Action Item",

	// TeamingTiptapTopic
	TeamingTiptapTopic_attribution: "added by {name}",

	// TeamingTiptapSlashCommands
	TeamingTiptapSlashCommands_topic: "Topic",
	TeamingTiptapSlashCommands_actionItem: "Action Item",
	TeamingTiptapSlashCommands_decision: "Decision",
	TeamingTiptapSlashCommands_noMatch: "(no match)",

	// TeamListPlaceholder
	TeamListPlaceholder_noTeamsMessage: "You have no active teams.",
	TeamListPlaceholder_subtitle: "",
	TeamListPlaceholder_createButton: "Create your first team",

	// TeamListHeaderCard
	TeamListHeaderCard_nameColumnHeader: "Team Name",
	TeamListHeaderCard_leadsColumnHeader: "Leads",
	TeamListHeaderCard_membersColumnHeader: "Members",

	//
	// NewOneOnOneDialog
	//
	NewOneOnOneDialog_heading: "New 1:1 Relationship",
	NewOneOnOneDialog_createButton: "Create 1:1",
	NewOneOnOneDialog_cancelButton: "Cancel",
	NewOneOnOneDialog_subHeading: "Your Teammate",
	NewOneOnOneDialog_whoIsRelationshipWithHint: "Who is this 1:1 relationship with?",
	NewOneOnOneDialog_emailFieldLabel: "Their email",
	NewOneOnOneDialog_emailFieldPlaceholder: "e.g., snape{'@'}hogwarts.edu",
	NewOneOnOneDialog_emailFieldHint: "Enter the email of the person you wish to invite to this 1:1. If we find an Opre user with that email, they will be displayed in a list.",
	NewOneOnOneDialog_roleFieldLabel: "Their role",
	NewOneOnOneDialog_roleFieldHint: "Does this person report to you, manage you, or is this a peer relationship?",
	NewOneOnOneDialog_roleFieldValidationError: "Invalid user role.",
	NewOneOnOneDialog_emailFieldValidationError1: "A valid email address is required.",
	NewOneOnOneDialog_emailFieldValidationError2: "It seems you are already in this 1:1. Invite someone else?",
	NewOneOnOneDialog_deferTitle: "Defer Invitation",
	NewOneOnOneDialog_deferDescription: "If you’re not quite ready for us to send an invitation to your teammate, check this box. You’ll be able to send the invitation later on.",

	// OneOnOneRoleDropdown
	[ `OneOnOneRoleDropdown_${ OneOnOneTeamRoleType.MANAGER }Option` ]: "Manager",
	[ `OneOnOneRoleDropdown_${ OneOnOneTeamRoleType.REPORT }Option` ]: "Report",
	[ `OneOnOneRoleDropdown_${ OneOnOneTeamRoleType.PEER }Option` ]: "Peer",

	// TeamRoleDropdown
	[ `TeamRoleDropdown_${ TeamRoleType.LEAD }Option` ]: "Lead",
	[ `TeamRoleDropdown_${ TeamRoleType.MEMBER }Option` ]: "Member",

	//
	// NoteHistoryMenu
	//
	NoteHistoryMenu_title: "Meeting History",
	NoteHistoryMenu_sharedNotesLabel: "Shared notes",
	NoteHistoryMenu_privateNotesLabel: "Private notes",
	NoteHistoryMenu_todayLabel: "Today, {date}",

	//
	// ConfirmationDialog
	//
	TrialEndDialog_title: "Your 14-day free trial has ended",
	TrialEndDialog_bodyHTML: [
		`<p>For a limited time, we're offering our $30 Team Insights package for $20 per person, per month. On the next payment screen, please indicate the number of team members on your team to subscribe.</p>`,
		`<p>If you or your team have questions, or need more time to evaluate Opre, `,
		`<a href="#" data-action="schedule">schedule a time</a> to talk or <a href="#" data-action="chat">chat with us now</a>.</p>`,
	].join( "" ),
	TrialEndDialog_subscribeNowButton: "Continue",

	//
	// DateChangeDialog
	//
	DateChangeDialog_title: "Change note date",
	DateChangeDialog_btnSubmit: "Change date",
	DateChangeDialog_btnCancel: "Cancel",
};
/* eslint-enable camelcase */
